import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { InvoiceRowDto } from '@sr/dto';
import { PurchasePicker } from 'shared/ui/formik-fields/purchases-picker';
import { Field, Form, Formik } from 'formik';
import { InvoicePicker } from 'shared/ui/formik-fields/invoice-picker';
import { InvoiceRowPicker } from 'shared/ui/formik-fields/invoice-row-picker';

type DialogProps = {
  open: boolean;
  onClose: () => void;
  row: InvoiceRowDto;
  onSubmit: (id: number, rowId: number, type: 'purchase' | 'invoiceRow') => Promise<void>;
};

const LinkRowPurchaseDialog = ({ open, onClose, onSubmit, row }: DialogProps) => {
  
  return (
    <Dialog onClose={onClose} open={open} fullWidth>
      <DialogTitle>Привяжите заявку или счёт</DialogTitle>
      <DialogContent>
        <Formik
          initialValues={{ purchase: 0, invoice: 0, invoiceRow: null }}
          onSubmit={async (values) => {
            if (values.purchase) {
              await onSubmit(values.purchase, row.id, 'purchase');
              onClose();
            } else if (values.invoiceRow) {
              await onSubmit(values.invoiceRow, row.id, 'invoiceRow');
              onClose();
            }
          }}
        >
          {({ submitForm, isSubmitting, values, setFieldValue }) => {
            const isPurchaseSelected = !!values.purchase;
            const isInvoiceRowSelected = !!values.invoiceRow;
            const isAnySelected = isPurchaseSelected || isInvoiceRowSelected;
            
            return (
              <>
                <DialogContentText>
                  <Form>
                    <div style={{ marginBottom: '20px' }}>
                      <Field 
                        name="purchase" 
                        label="Заявка" 
                        component={PurchasePicker} 
                        invoiceRowId={row.id}
                        disabled={!!values.invoice} 
                        onChange={(e: any, newValue: any) => {
                          if (newValue) {
                            setFieldValue('invoice', 0);
                            setFieldValue('invoiceRow', null);
                          }
                        }}
                      />
                    </div>
                    
                    <div style={{ margin: '20px 0', textAlign: 'center' }}>ИЛИ</div>
                    
                    <div style={{ marginBottom: '20px' }}>
                      <Field 
                        name="invoice" 
                        label="Счёт" 
                        component={InvoicePicker} 
                        disabled={!!values.purchase} 
                        notPurchase={true}
                        onChange={(e: any, newValue: any) => {
                          if (newValue) {
                            setFieldValue('purchase', 0);
                            setFieldValue('invoiceRow', null);
                          } else {
                            setFieldValue('invoiceRow', null);
                          }
                        }}
                      />
                    </div>
                    
                    <div>
                      <Field 
                        name="invoiceRow" 
                        label="Строка счёта" 
                        component={InvoiceRowPicker}
                        invoiceId={values.invoice}
                        disabled={!values.invoice} 
                      />
                    </div>
                  </Form>
                </DialogContentText>
                <DialogActions>
                  <Button 
                    variant="contained" 
                    autoFocus 
                    disabled={isSubmitting || !isAnySelected} 
                    onClick={submitForm}
                  >
                    Сохранить
                  </Button>
                  <Button variant="outlined" onClick={onClose}>
                    Закрыть
                  </Button>
                </DialogActions>
              </>
            );
          }}
        </Formik>
      </DialogContent>
    </Dialog>
  );
};

export default LinkRowPurchaseDialog;